module.exports = __webpack_public_path__ + "img/3.247fba09.jpg";